export default "/images/8a654ebae89bdc184d63f6c52cbfdedf.avif";